import angular from 'angular'

import component from './tooltip.component'

let module = angular.module('tooltipModule', [])

.component('tooltip', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/tooltip/index.js